"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IOS_LINK = exports.DISCONNECTED = exports.CONNECTING = exports.CONNECTED = exports.ANDROID_LINK = void 0;
const IOS_LINK = 'https://apps.apple.com/app/apple-store/id1464614025?pt=118781877&ct=mc&mt=8';
exports.IOS_LINK = IOS_LINK;
const ANDROID_LINK = 'https://play.google.com/store/apps/details?id=com.myetherwallet.mewwallet&referrer=utm_source%3Dmc';
exports.ANDROID_LINK = ANDROID_LINK;
const DISCONNECTED = 'disconnected';
exports.DISCONNECTED = DISCONNECTED;
const CONNECTING = 'connecting';
exports.CONNECTING = CONNECTING;
const CONNECTED = 'connected';
exports.CONNECTED = CONNECTED;